/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { PickListThemeFromJSON, PickListThemeToJSON, TextThemeFromJSON, TextThemeToJSON, } from './';
export function TutorialThemeFromJSON(json) {
    return TutorialThemeFromJSONTyped(json, false);
}
export function TutorialThemeFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'text': !exists(json, 'text') ? undefined : TextThemeFromJSON(json['text']),
        'pickList': !exists(json, 'pick_list') ? undefined : PickListThemeFromJSON(json['pick_list']),
    };
}
export function TutorialThemeToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'text': TextThemeToJSON(value.text),
        'pick_list': PickListThemeToJSON(value.pickList),
    };
}
//# sourceMappingURL=TutorialTheme.js.map